import { render, staticRenderFns } from "./gdCarBoard.vue?vue&type=template&id=89016898&scoped=true"
import script from "./gdCarBoard.vue?vue&type=script&lang=js"
export * from "./gdCarBoard.vue?vue&type=script&lang=js"
import style0 from "./gdCarBoard.vue?vue&type=style&index=0&id=89016898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89016898",
  null
  
)

export default component.exports